const UserData = () => {
    return {
        users: [
            {
                userId: 'ceno',
                userName: {
                    first: 'Caleb',
                    last: 'Eno'
                },
                email: 'ceno@icct.com'
            },
            {
                userId: 'sroxas',
                userName: {
                    first: 'Sora',
                    last: 'Roxas'
                },
                email: 'sroxas@kingdom.com'
            },
            {
                userId: 'dduck',
                userName: {
                    first: 'Donald',
                    last: 'Duck'
                },
                email: 'dduck@kingdom.com'
            },
            {
                userId: 'gdog',
                userName: {
                    first: 'Goofy',
                    last: 'Dog'
                },
                email: 'gdog@kingdom.com'
            },
            {
                userId: 'mmouse',
                userName: {
                    first: 'Mickey',
                    last: 'Mouse'
                },
                email: 'mmouse@kingd.com'
            },
            {
                userId: 'afiore',
                userName: {
                    first: 'Amber',
                    last: 'Fiore'
                },
                email: 'afiore@icct.com'
            },
            {
                userId: 'sblake',
                userName: {
                    first: 'Siobhan',
                    last: 'Blake'
                },
                email: 'sblake@icct.com'
            },
            {
                userId: 'gbaker',
                userName: {
                    first: 'Gary',
                    last: 'Baker'
                },
                email: 'gbaker@icct.com'
            }
        ]
    }
};

export default UserData;



/** WEBPACK FOOTER **
 ** ./src/data/users.js
 **/